module.exports = new __parcel__URL__("C8S1.4a4dcbb0.png").toString();